[
  [
    {
      "id": "blade-ward",
      "title": "Blade Ward",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:blade-ward"
    },
    {
      "id": "dancing-lights",
      "title": "Dancing Lights",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:dancing-lights"
    },
    {
      "id": "friends",
      "title": "Friends",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:friends"
    },
    {
      "id": "light",
      "title": "Light",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:light"
    },
    {
      "id": "mage-hand",
      "title": "Mage Hand",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mage-hand"
    },
    {
      "id": "mending",
      "title": "Mending",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mending"
    },
    {
      "id": "message",
      "title": "Message",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:message"
    },
    {
      "id": "minor-illusion",
      "title": "Minor Illusion",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:minor-illusion"
    },
    {
      "id": "prestidigitation",
      "title": "Prestidigitation",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:prestidigitation"
    },
    {
      "id": "thunderclap",
      "title": "Thunderclap",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:thunderclap"
    },
    {
      "id": "true-strike",
      "title": "True Strike",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:true-strike"
    },
    {
      "id": "vicious-mockery",
      "title": "Vicious Mockery",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:vicious-mockery"
    }
  ],
  [
    {
      "id": "animal-friendship",
      "title": "Animal Friendship",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:animal-friendship"
    },
    {
      "id": "bane",
      "title": "Bane",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:bane"
    },
    {
      "id": "charm-person",
      "title": "Charm Person",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:charm-person"
    },
    {
      "id": "color-spray",
      "title": "Color Spray",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:color-spray"
    },
    {
      "id": "command",
      "title": "Command",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:command"
    },
    {
      "id": "comprehend-languages",
      "title": "Comprehend Languages",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:comprehend-languages"
    },
    {
      "id": "cure-wounds",
      "title": "Cure Wounds",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:cure-wounds"
    },
    {
      "id": "detect-magic",
      "title": "Detect Magic",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-magic"
    },
    {
      "id": "disguise-self",
      "title": "Disguise Self",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:disguise-self"
    },
    {
      "id": "dissonant-whispers",
      "title": "Dissonant Whispers",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:dissonant-whispers"
    },
    {
      "id": "distort-value",
      "title": "Distort Value",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:distort-value"
    },
    {
      "id": "earth-tremor",
      "title": "Earth Tremor",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:earth-tremor"
    },
    {
      "id": "faerie-fire",
      "title": "Faerie Fire",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:faerie-fire"
    },
    {
      "id": "feather-fall",
      "title": "Feather Fall",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:feather-fall"
    },
    {
      "id": "guiding-hand-ua",
      "title": "Guiding Hand (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:guiding-hand-ua"
    },
    {
      "id": "healing-word",
      "title": "Healing Word",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:healing-word"
    },
    {
      "id": "heroism",
      "title": "Heroism",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:heroism"
    },
    {
      "id": "identify",
      "title": "Identify",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:identify"
    },
    {
      "id": "illusory-script",
      "title": "Illusory Script",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:illusory-script"
    },
    {
      "id": "longstrider",
      "title": "Longstrider",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:longstrider"
    },
    {
      "id": "puppet",
      "title": "Puppet (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:puppet"
    },
    {
      "id": "sense-emotion",
      "title": "Sense Emotion (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sense-emotion"
    },
    {
      "id": "silent-image",
      "title": "Silent Image",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:silent-image"
    },
    {
      "id": "silvery-barbs",
      "title": "Silvery Barbs",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:silvery-barbs"
    },
    {
      "id": "sleep",
      "title": "Sleep",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sleep"
    },
    {
      "id": "speak-with-animals",
      "title": "Speak with Animals",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:speak-with-animals"
    },
    {
      "id": "sudden-awakening",
      "title": "Sudden Awakening (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sudden-awakening"
    },
    {
      "id": "tashas-hideous-laughter",
      "title": "Tasha's Hideous Laughter",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:tashas-hideous-laughter"
    },
    {
      "id": "thunderwave",
      "title": "Thunderwave",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:thunderwave"
    },
    {
      "id": "unearthly-chorus",
      "title": "Unearthly Chorus (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:unearthly-chorus"
    },
    {
      "id": "unseen-servant",
      "title": "Unseen Servant",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:unseen-servant"
    }
  ],
  [
    {
      "id": "aid",
      "title": "Aid",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:aid"
    },
    {
      "id": "animal-messenger",
      "title": "Animal Messenger",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:animal-messenger"
    },
    {
      "id": "blindness-deafness",
      "title": "Blindness/Deafness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:blindness-deafness"
    },
    {
      "id": "borrowed-knowledge",
      "title": "Borrowed Knowledge",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:borrowed-knowledge"
    },
    {
      "id": "calm-emotions",
      "title": "Calm Emotions",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:calm-emotions"
    },
    {
      "id": "cloud-of-daggers",
      "title": "Cloud of Daggers",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:cloud-of-daggers"
    },
    {
      "id": "crown-of-madness",
      "title": "Crown of Madness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:crown-of-madness"
    },
    {
      "id": "detect-thoughts",
      "title": "Detect Thoughts",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:detect-thoughts"
    },
    {
      "id": "enhance-ability",
      "title": "Enhance Ability",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enhance-ability"
    },
    {
      "id": "enlarge-reduce",
      "title": "Enlarge/Reduce",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enlarge-reduce"
    },
    {
      "id": "enthrall",
      "title": "Enthrall",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enthrall"
    },
    {
      "id": "gift-of-gab",
      "title": "Gift of Gab",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:gift-of-gab"
    },
    {
      "id": "heat-metal",
      "title": "Heat Metal",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:heat-metal"
    },
    {
      "id": "hold-person",
      "title": "Hold Person",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:hold-person"
    },
    {
      "id": "invisibility",
      "title": "Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:invisibility"
    },
    {
      "id": "kinetic-jaunt",
      "title": "Kinetic Jaunt",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:kinetic-jaunt"
    },
    {
      "id": "knock",
      "title": "Knock",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:knock"
    },
    {
      "id": "lesser-restoration",
      "title": "Lesser Restoration",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:lesser-restoration"
    },
    {
      "id": "locate-animals-or-plants",
      "title": "Locate Animals or Plants",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:locate-animals-or-plants"
    },
    {
      "id": "locate-object",
      "title": "Locate Object",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:locate-object"
    },
    {
      "id": "magic-mouth",
      "title": "Magic Mouth",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:magic-mouth"
    },
    {
      "id": "mirror-image",
      "title": "Mirror Image",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:mirror-image"
    },
    {
      "id": "nathairs-mischief",
      "title": "Nathair's Mischief",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:nathairs-mischief"
    },
    {
      "id": "nathairs-mischief-ua",
      "title": "Nathair's Mischief (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:nathairs-mischief-ua"
    },
    {
      "id": "phantasmal-force",
      "title": "Phantasmal Force",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:phantasmal-force"
    },
    {
      "id": "pyrotechnics",
      "title": "Pyrotechnics",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:pyrotechnics"
    },
    {
      "id": "see-invisibility",
      "title": "See Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:see-invisibility"
    },
    {
      "id": "shatter",
      "title": "Shatter",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:shatter"
    },
    {
      "id": "silence",
      "title": "Silence",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:silence"
    },
    {
      "id": "skywrite",
      "title": "Skywrite",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:skywrite"
    },
    {
      "id": "spray-of-cards",
      "title": "Spray Of Cards",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spray-of-cards"
    },
    {
      "id": "spray-of-cards-ua",
      "title": "Spray of Cards (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spray-of-cards-ua"
    },
    {
      "id": "suggestion",
      "title": "Suggestion",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:suggestion"
    },
    {
      "id": "warding-wind",
      "title": "Warding Wind",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:warding-wind"
    },
    {
      "id": "zone-of-truth",
      "title": "Zone of Truth",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:zone-of-truth"
    }
  ],
  [
    {
      "id": "antagonize",
      "title": "Antagonize",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:antagonize"
    },
    {
      "id": "antagonize-ua",
      "title": "Antagonize (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:antagonize-ua"
    },
    {
      "id": "bestow-curse",
      "title": "Bestow Curse",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:bestow-curse"
    },
    {
      "id": "catnap",
      "title": "Catnap",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:catnap"
    },
    {
      "id": "clairvoyance",
      "title": "Clairvoyance",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:clairvoyance"
    },
    {
      "id": "dispel-magic",
      "title": "Dispel Magic",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:dispel-magic"
    },
    {
      "id": "enemies-abound",
      "title": "Enemies Abound",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:enemies-abound"
    },
    {
      "id": "fast-friends",
      "title": "Fast Friends",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fast-friends"
    },
    {
      "id": "fear",
      "title": "Fear",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fear"
    },
    {
      "id": "feign-death",
      "title": "Feign Death",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:feign-death"
    },
    {
      "id": "glyph-of-warding",
      "title": "Glyph of Warding",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:glyph-of-warding"
    },
    {
      "id": "house-of-cards-ua",
      "title": "House of Cards (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:house-of-cards-ua"
    },
    {
      "id": "hypnotic-pattern",
      "title": "Hypnotic Pattern",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:hypnotic-pattern"
    },
    {
      "id": "intellect-fortress",
      "title": "Intellect Fortress",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:intellect-fortress"
    },
    {
      "id": "leomunds-tiny-hut",
      "title": "Leomund's Tiny Hut",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:leomunds-tiny-hut"
    },
    {
      "id": "major-image",
      "title": "Major Image",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:major-image"
    },
    {
      "id": "mass-healing-word",
      "title": "Mass Healing Word",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:mass-healing-word"
    },
    {
      "id": "motivational-speech",
      "title": "Motivational Speech",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:motivational-speech"
    },
    {
      "id": "nondetection",
      "title": "Nondetection",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:nondetection"
    },
    {
      "id": "plant-growth",
      "title": "Plant Growth",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:plant-growth"
    },
    {
      "id": "sending",
      "title": "Sending",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:sending"
    },
    {
      "id": "slow",
      "title": "Slow",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:slow"
    },
    {
      "id": "speak-with-dead",
      "title": "Speak with Dead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:speak-with-dead"
    },
    {
      "id": "speak-with-plants",
      "title": "Speak with Plants",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:speak-with-plants"
    },
    {
      "id": "stinking-cloud",
      "title": "Stinking Cloud",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:stinking-cloud"
    },
    {
      "id": "tongues",
      "title": "Tongues",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tongues"
    }
  ],
  [
    {
      "id": "charm-monster",
      "title": "Charm Monster",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:charm-monster"
    },
    {
      "id": "compulsion",
      "title": "Compulsion",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:compulsion"
    },
    {
      "id": "confusion",
      "title": "Confusion",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:confusion"
    },
    {
      "id": "dimension-door",
      "title": "Dimension Door",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:dimension-door"
    },
    {
      "id": "ego-whip",
      "title": "Ego Whip (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:ego-whip"
    },
    {
      "id": "freedom-of-movement",
      "title": "Freedom of Movement",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:freedom-of-movement"
    },
    {
      "id": "greater-invisibility",
      "title": "Greater Invisibility",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:greater-invisibility"
    },
    {
      "id": "hallucinatory-terrain",
      "title": "Hallucinatory Terrain",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:hallucinatory-terrain"
    },
    {
      "id": "locate-creature",
      "title": "Locate Creature",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:locate-creature"
    },
    {
      "id": "phantasmal-killer",
      "title": "Phantasmal Killer",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:phantasmal-killer"
    },
    {
      "id": "polymorph",
      "title": "Polymorph",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:polymorph"
    },
    {
      "id": "raulothims-psychic-lance",
      "title": "Raulothim's Psychic Lance",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:raulothims-psychic-lance"
    },
    {
      "id": "raulothims-psychic-lance-ua",
      "title": "Raulothim's Psychic Lance (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:raulothims-psychic-lance-ua"
    }
  ],
  [
    {
      "id": "animate-objects",
      "title": "Animate Objects",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:animate-objects"
    },
    {
      "id": "awaken",
      "title": "Awaken",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:awaken"
    },
    {
      "id": "dominate-person",
      "title": "Dominate Person",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dominate-person"
    },
    {
      "id": "dream",
      "title": "Dream",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dream"
    },
    {
      "id": "geas",
      "title": "Geas",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:geas"
    },
    {
      "id": "greater-restoration",
      "title": "Greater Restoration",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:greater-restoration"
    },
    {
      "id": "hold-monster",
      "title": "Hold Monster",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:hold-monster"
    },
    {
      "id": "legend-lore",
      "title": "Legend Lore",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:legend-lore"
    },
    {
      "id": "mass-cure-wounds",
      "title": "Mass Cure Wounds",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:mass-cure-wounds"
    },
    {
      "id": "mislead",
      "title": "Mislead",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:mislead"
    },
    {
      "id": "modify-memory",
      "title": "Modify Memory",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:modify-memory"
    },
    {
      "id": "planar-binding",
      "title": "Planar Binding",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:planar-binding"
    },
    {
      "id": "raise-dead",
      "title": "Raise Dead",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:raise-dead"
    },
    {
      "id": "rarys-telepathic-bond",
      "title": "Rary's Telepathic Bond",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:rarys-telepathic-bond"
    },
    {
      "id": "scrying",
      "title": "Scrying",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:scrying"
    },
    {
      "id": "seeming",
      "title": "Seeming",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:seeming"
    },
    {
      "id": "skill-empowerment",
      "title": "Skill Empowerment",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:skill-empowerment"
    },
    {
      "id": "synaptic-static",
      "title": "Synaptic Static",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:synaptic-static"
    },
    {
      "id": "teleportation-circle",
      "title": "Teleportation Circle",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:teleportation-circle"
    }
  ],
  [
    {
      "id": "eyebite",
      "title": "Eyebite",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:eyebite"
    },
    {
      "id": "find-the-path",
      "title": "Find the Path",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:find-the-path"
    },
    {
      "id": "guards-and-wards",
      "title": "Guards and Wards",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:guards-and-wards"
    },
    {
      "id": "heroes-feast",
      "title": "Heroes' Feast",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:heroes-feast"
    },
    {
      "id": "mass-suggestion",
      "title": "Mass Suggestion",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:mass-suggestion"
    },
    {
      "id": "ottos-irresistible-dance",
      "title": "Otto's Irresistible Dance",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:ottos-irresistible-dance"
    },
    {
      "id": "programmed-illusion",
      "title": "Programmed Illusion",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:programmed-illusion"
    },
    {
      "id": "true-seeing",
      "title": "True Seeing",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:true-seeing"
    }
  ],
  [
    {
      "id": "dream-of-the-blue-veil",
      "title": "Dream of the Blue Veil",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:dream-of-the-blue-veil"
    },
    {
      "id": "etherealness",
      "title": "Etherealness",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:etherealness"
    },
    {
      "id": "forcecage",
      "title": "Forcecage",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:forcecage"
    },
    {
      "id": "mirage-arcane",
      "title": "Mirage Arcane",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mirage-arcane"
    },
    {
      "id": "mordenkainens-magnificent-mansion",
      "title": "Mordenkainen's Magnificent Mansion",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-magnificent-mansion"
    },
    {
      "id": "mordenkainens-sword",
      "title": "Mordenkainen's Sword",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-sword"
    },
    {
      "id": "prismatic-spray",
      "title": "Prismatic Spray",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:prismatic-spray"
    },
    {
      "id": "project-image",
      "title": "Project Image",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:project-image"
    },
    {
      "id": "regenerate",
      "title": "Regenerate",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:regenerate"
    },
    {
      "id": "resurrection",
      "title": "Resurrection",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:resurrection"
    },
    {
      "id": "symbol",
      "title": "Symbol",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:symbol"
    },
    {
      "id": "teleport",
      "title": "Teleport",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:teleport"
    }
  ],
  [
    {
      "id": "antipathy-sympathy",
      "title": "Antipathy/Sympathy",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:antipathy-sympathy"
    },
    {
      "id": "dominate-monster",
      "title": "Dominate Monster",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:dominate-monster"
    },
    {
      "id": "feeblemind",
      "title": "Feeblemind",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:feeblemind"
    },
    {
      "id": "glibness",
      "title": "Glibness",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:glibness"
    },
    {
      "id": "mind-blank",
      "title": "Mind Blank",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:mind-blank"
    },
    {
      "id": "power-word-stun",
      "title": "Power Word: Stun",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:power-word-stun"
    }
  ],
  [
    {
      "id": "foresight",
      "title": "Foresight",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:foresight"
    },
    {
      "id": "mass-polymorph",
      "title": "Mass Polymorph",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:mass-polymorph"
    },
    {
      "id": "power-word-heal",
      "title": "Power Word: Heal",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:power-word-heal"
    },
    {
      "id": "power-word-kill",
      "title": "Power Word: Kill",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:power-word-kill"
    },
    {
      "id": "prismatic-wall",
      "title": "Prismatic Wall",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:prismatic-wall"
    },
    {
      "id": "psychic-scream",
      "title": "Psychic Scream",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:psychic-scream"
    },
    {
      "id": "true-polymorph",
      "title": "True Polymorph",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:true-polymorph"
    }
  ]
]
